import "./sw-reader.module.css";
import { html, LANGUAGE, isApple } from "../../global.ts";
import Strings from "../../../models/Strings.json";
//import { unsafeHTML } from "lit-html/directives/unsafe-html.js";

const template = document.createElement("template");
template.innerHTML = html`
    <div
        id="sw-reader"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        onclick="heartbank.alertAdmin('reader/click/editor')"
                        class="text-xl md:text-2xl font-semibold text-theme">
                        <button
                            class="hidden mr-2"
                            title="${Strings.editor[LANGUAGE]}">
                            📝
                        </button>
                        <span id="sw-reader-title"></span>
                    </h3>
                    <section>
                        <button
                            title="${Strings.speak2[LANGUAGE]}"
                            id="sw-reader-speak"
                            ontouchstart=""
                            onclick="heartbank.alertAdmin('reader/click/speak')"
                            type="button"
                            class="text-xl md:text-2xl mr-3 md:mr-5">
                            🔈
                        </button>
                        <button
                            title="${Strings.dict2[LANGUAGE]}"
                            id="sw-reader-dict2"
                            ontouchstart=""
                            onclick="heartbank.alertAdmin('reader/render/dictionary')"
                            type="button"
                            class="text-xl md:text-2xl mr-3 md:mr-5">
                            📖
                        </button>
                        <button
                            title="${Strings.copyall[LANGUAGE]}"
                            id="sw-reader-copy"
                            ontouchstart=""
                            onclick="heartbank.alertAdmin('reader/render/copy-all')"
                            type="button"
                            class="text-xl md:text-2xl mr-3 md:mr-5">
                            📑
                        </button>
                        <button
                            title="${Strings.close[LANGUAGE]}"
                            id="sw-reader-close2"
                            ontouchstart=""
                            type="button"
                            class="text-xl md:text-2xl">
                            ❌
                        </button>
                    </section>
                    <button
                        title="${Strings.close[LANGUAGE]}"
                        id="sw-reader-close3"
                        type="button"
                        class="hidden text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">${Strings.close[LANGUAGE]}</span>
                    </button>
                </div>
                <!-- Modal body -->
                <div
                    class="battambang p-4 md:p-5 space-y-4 leading-[2] text-gray-900 dark:text-white">
                    <div id="sw-reader-body">
                        <p class="text-xl break-words break-keep2"></p>
                        <p class="text-2xl break-words break-keep2"></p>
                    </div>
                    <div
                        id="sw-reader-pager"
                        class="relative pt-5 flex items-center max-w-44 mx-auto">
                        <button
                            type="button"
                            id="sw-reader-pager-decrement"
                            onclick="heartbank.alertAdmin('reader/click/previous-page')"
                            data-input-counter-decrement="page-number"
                            class="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                            <svg
                                class="text-gray-900 dark:text-white"
                                aria-hidden="true"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                height="14"
                                width="12.25"
                                viewBox="0 0 448 512">
                                <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                <path
                                    d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
                            </svg>
                        </button>
                        <input
                            inputmode="numeric"
                            id="sw-reader-pager-number"
                            onblur="heartbank.alertAdmin('reader/type/', this.value)"
                            type="text"
                            data-input-counter2
                            data-input-counter-min2="0"
                            data-input-counter-max2=""
                            aria-describedby="helper-text-explanation"
                            class="bg-gray-50 border-x-0 border-gray-300 h-11 font-medium text-center text-gray-900 text-lg outline-none focus:ring-0 focus:border-none focus:ring-blue-500 focus:border-blue-500 block w-full pb-6 dark:bg-gray-700 dark:border-gray-600 placeholder-gray-400 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="${Strings.page[LANGUAGE]}"
                            value="0" />
                        <div
                            id="sw-reader-pager-total"
                            class="absolute bottom-1 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 flex items-center text-xs text-gray-400 space-x-1 rtl:space-x-reverse">
                            1 ${Strings.total[LANGUAGE]}
                        </div>
                        <button
                            type="button"
                            id="sw-reader-pager-increment"
                            onclick="heartbank.alertAdmin('reader/click/next-page')"
                            data-input-counter-increment="page-number"
                            class="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                            <svg
                                class="text-gray-900 dark:text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                fill="currentColor"
                                height="14"
                                width="12.25"
                                viewBox="0 0 448 512">
                                <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                <path
                                    d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                            </svg>
                        </button>
                    </div>
                    <p
                        onclick="heartbank.alertAdmin('reader/click/feedback');prompt('${Strings
                            .typo2[LANGUAGE]}','${Strings.soon[LANGUAGE]}')"
                        class="font-thin text-sm text-gray-500 dark:text-gray-400 text-center italic underline cursor-pointer">
                        ${Strings.typo[LANGUAGE]}
                    </p>
                </div>
                <!-- Modal footer -->
                <div
                    class="hidden items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        id="sw-reader-tutor"
                        ontouchstart=""
                        onclick="heartbank.alertAdmin('reader/click/tutor')"
                        type="button"
                        class="w-24 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        ${Strings.tutor[LANGUAGE]}
                    </button>
                    <button
                        id="sw-reader-quiz"
                        ontouchstart=""
                        onclick="heartbank.alertAdmin('reader/click/quiz')"
                        type="button"
                        class="w-24 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        ${Strings.quiz[LANGUAGE]}
                    </button>
                    <button
                        id="sw-reader-google"
                        onclick="heartbank.alertAdmin('reader/click/google-translate')"
                        type="button"
                        class="${isApple
                            ? "hidden"
                            : "hidden"} w-24 text-white bg-basket2 hover:bg-orange-800 focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket2 dark:hover:bg-orange-700 dark:focus:ring-orange-800">
                        ${Strings.google[LANGUAGE]}
                    </button>
                    <button
                        id="sw-reader-other"
                        onclick="heartbank.alertAdmin('reader/click/other-ai')"
                        type="button"
                        class="hidden w-24 text-white bg-basket3 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket3 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        ${Strings.other[LANGUAGE]}
                    </button>
                    <button
                        id="sw-reader-close"
                        type="button"
                        class="hidden w-24 text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        ${Strings.close[LANGUAGE]}
                    </button>
                </div>
                <div
                    class="flex items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        id="sw-reader-gemini"
                        onclick="heartbank.alertAdmin('reader/click/gemini-ai')"
                        type="button"
                        class="w-24 text-white bg-basket2 hover:bg-orange-800 focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket2 dark:hover:bg-orange-700 dark:focus:ring-orange-800">
                        ${Strings.gemini[LANGUAGE]}
                    </button>
                    <button
                        id="sw-reader-dict"
                        onclick="heartbank.alertAdmin('reader/click/dictionary')"
                        type="button"
                        class="w-24 text-white bg-basket1 hover:bg-yellow-800 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket1 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">
                        ${Strings.dict[LANGUAGE]}
                    </button>
                    <button
                        id="sw-reader-grok"
                        onclick="heartbank.alertAdmin('reader/click/grok-ai')"
                        type="button"
                        class="w-24 text-white bg-basket2 hover:bg-orange-800 focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket2 dark:hover:bg-orange-700 dark:focus:ring-orange-800">
                        ${Strings.grok[LANGUAGE]}
                    </button>
                </div>
                <div
                    id="sw-reader-admin"
                    class="hidden items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        id="sw-reader-deepseek"
                        onclick="heartbank.alertAdmin('reader/click/deepseek-ai')"
                        type="button"
                        class="w-24 text-white bg-basket3 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket3 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        ${Strings.deepseek[LANGUAGE]}
                    </button>
                    <button
                        id="sw-reader-meta"
                        onclick="heartbank.alertAdmin('reader/click/meta-ai')"
                        type="button"
                        class="w-24 text-white bg-basket3 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket3 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        ${Strings.meta[LANGUAGE]}
                    </button>
                    <button
                        id="sw-reader-chatgpt"
                        onclick="heartbank.alertAdmin('reader/click/chat-gpt')"
                        type="button"
                        class="w-24 text-white bg-basket3 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket3 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        ${Strings.chatgpt[LANGUAGE]}
                    </button>
                </div>
            </div>
        </div>
    </div>
`;

export default template;
